import { MgItemDocumentationDTO, SupplierItemDocumentationDTO } from '../../dto';
import { Documentation } from './Documentation';
import { EnvironmentalDocumentation } from './EnvironmentalDocumentation';
import { Supplier } from './MgSupplierItemSearchResult2';

export interface MgItemDocumentationProps {
  mgItemNumber: number;
  mgSupplierItems: SupplierItemDocumentation[];
}

export class MgItemDocumentation {
  mgItemNumber: number;
  mgSupplierItems: SupplierItemDocumentation[];
  constructor({ mgItemNumber, mgSupplierItems }: MgItemDocumentationProps) {
    this.mgItemNumber = mgItemNumber;
    this.mgSupplierItems = mgSupplierItems;
  }

  static fromDto = (dto: MgItemDocumentationDTO): MgItemDocumentation =>
    new MgItemDocumentation({
      mgItemNumber: dto.mgItemNumber,
      mgSupplierItems: dto.mgSupplierItems.map(SupplierItemDocumentation.fromDto),
    });
}

export interface SupplierItemDocumentationProps {
  supplier: Supplier;
  documentation: Documentation;
  environmentalDocumentation: EnvironmentalDocumentation;
}

export class SupplierItemDocumentation {
  supplier: Supplier;
  documentation: Documentation;
  environmentalDocumentation: EnvironmentalDocumentation;
  constructor({
    supplier,
    documentation,
    environmentalDocumentation,
  }: SupplierItemDocumentationProps) {
    this.supplier = supplier;
    this.documentation = documentation;
    this.environmentalDocumentation = environmentalDocumentation;
  }
  static fromDto = (dto: SupplierItemDocumentationDTO): SupplierItemDocumentation =>
    new SupplierItemDocumentation({
      supplier: dto.supplier,
      documentation: Documentation.fromDto(dto.documentation),
      environmentalDocumentation: EnvironmentalDocumentation.fromDto(
        dto.environmentalDocumentation
      ),
    });
}
